<template>
    <div
        class="sc-message--text"
        :class="{
            translatable: isTranslatable(),
            emoji: isEmoji(),
        }"
    >
        <QuoteMessage :message="message.raw.replyTo" v-if="message.raw.replyTo && !replyMode" />
        <template>
            <div :style="{ background: messageColors.backgroundColor }" id="abc0" class="sc-message--toolbox">
                <button v-if="me && message.id != null && message.id != undefined" :disabled="isEditing" @click="edit">
                    <icon-base :color="isEditing ? 'black' : messageColors.color" icon-name="edit" width="10">
                        <icon-edit />
                    </icon-base>
                </button>
                <button v-if="me && message.id != null && message.id != undefined" @click="$emit('remove')">
                    <icon-base :color="messageColors.color" icon-name="remove" width="10">
                        <icon-cross />
                    </icon-base>
                </button>
                <slot :me="me" :message="message" name="text-message-toolbox"></slot>
            </div>
        </template>
        <div :class="{ 'translatable-content-wrapper': isTranslatable() }">
            <div :class="{ 'after-translate-top': isTranslatable() }">
                <slot :me="me" :message="message" :messageColors="messageColors" :messageText="messageText">
                    <span
                        class="sc-message--text-content"
                        style="margin-bottom: 0 !important"
                        v-html="messageText"
                    ></span>

                    <text
                        v-if="message.data.meta"
                        class="sc-message--meta"
                        style="color: darkcyan; font-weight: 600; font-size: smaller"
                    >
                        {{ message.data.meta }}
                    </text>
                    <text v-if="message.isEdited" class="sc-message--edited">
                        <icon-base icon-name="edited" width="10">
                            <icon-edit />
                        </icon-base>
                        edited
                    </text>
                </slot>
            </div>
            <div :class="{ 'after-translate-bottom': isTranslatable() }">
                <TranslatedText v-if="isTranslatable()" :data="message.raw.translates[0]">
                    <span
                        v-if="!!message.raw.translates.length && !me"
                        @click="openLangModal"
                        style="max-width: 5%; padding: 0; justify-content: center"
                    >
                        <p class="m-0" style="color: #1890ff; font-size: 10px">
                            <md-tooltip
                                md-direction="top"
                                style="
                                    color: var(--customer-text-color);
                                    background: var(--primary_);
                                    font-size: 9px;
                                    border-radius: 8px;
                                "
                            >
                                {{ $t("message.languageSelection") }}
                            </md-tooltip>
                            <a-icon class="text-info lang-setting-icon" type="setting" />
                        </p>
                    </span>
                </TranslatedText>
            </div>
        </div>
        <slot name="feedback" />
    </div>
</template>

<script>
import IconBase from "./../components/IconBase.vue";
import IconEdit from "./../components/icons/IconEdit.vue";
import IconCross from "../components/icons/IconCross.vue";
import { htmlUnescape } from "escape-goat";
import Autolinker from "autolinker";
import store from "./../store/";
import { log2 } from "../../../../utils/log2";
import TranslatedText from "../TranslatedText";
import { mapState } from "vuex";
import { publishMessage } from "../../../../utils/systemPubSub";
import _ from "lodash";
import QuoteMessage from "./QuoteMessage.vue";

const log = log2("TextMessage");
export default {
    name: "TextMessage",
    components: {
        QuoteMessage,
        TranslatedText,
        IconBase,
        IconCross,
        IconEdit,
    },
    props: {
        message: {
            type: Object,
            required: true,
        },
        messageColors: {
            type: Object,
            required: true,
        },
        messageStyling: {
            type: Boolean,
            required: true,
        },
        replyMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            store,
        };
    },
    computed: {
        ...mapState({
            autoTranslate: (state) => state.chat.autoTranslate,
        }),
        messageText() {
            let escaped = htmlUnescape(this.message.data.text.trim());

            let res = Autolinker.link(escaped, {
                className: "chatLink",
                truncate: { length: 50, location: "smart" },
            });
            res = this.fillLinkTargetBlank(res);
            // log.debug("message ->", {
            //     text: this.message.data.text,
            //     escapedAutolinked: res,
            // });
            res = res.replace(/<p>&nbsp;<\/p>$/gi, "");
            return res;
        },
        me() {
            return this.message.author === "me";
        },
        isEditing() {
            return (store.editMessage && store.editMessage.id) == this.message.id;
        },
    },
    methods: {
        isTranslatable() {
            try {
                const translates = _.get(this.message, "raw.translates", []) || [];
                const from = _.get(translates, "0.from", "") || "";
                const to = _.get(translates, "0.to", "") || "";
                const emoji = this.isEmoji();
                return translates.length > 0 && this.autoTranslate && !this.me && from !== to && !emoji;
            } catch (e) {
                console.error(e);
                return false;
            }
        },
        isEmoji() {
            try {
                const ranges = [
                    "\ud83c[\udf00-\udfff]", // U+1F300 to U+1F3FF
                    "\ud83d[\udc00-\ude4f]", // U+1F400 to U+1F64F
                    "\ud83d[\ude80-\udeff]", // U+1F680 to U+1F6FF
                ];
                const message = (this.messageText || "").trim();
                const regex = new RegExp(`^(${ranges.join("|")})$`);
                const el = document.createElement("div");
                el.innerHTML = message;
                const content = el.textContent || el.innerText || "";
                if (content.match(regex)) {
                    return true;
                } else {
                    return false;
                }
            } catch (e) {
                console.error(e);
                return false;
            }
        },

        fillLinkTargetBlank(str) {
            let parser = new DOMParser();
            let virtualDom = parser.parseFromString(str, "text/html");
            virtualDom.querySelectorAll("a").forEach((a) => {
                a.setAttribute("target", "_blank");
            });
            return virtualDom.body.innerHTML;
        },
        edit() {
            this.store.editMessage = this.message;
        },
        openLangModal() {
            publishMessage("open-lang-modal", true);
        },
        getLabel(code) {
            let maybeLang = this.languages.find((x) => x.code === code);
            return !!maybeLang ? maybeLang.originalName : code;
        },
    },
    mounted() {
        // log.debug("TextMessage.mounted", _.cloneDeep(this.message));
        log("mounted => ", {
            isEmoji: this.isEmoji(),
            isTranslatable: this.isTranslatable(),
        });
        this.$emit("isEmoji", this.isEmoji());
    },
};
</script>

<style lang="scss" scoped>
.translatable {
    padding: 0px 0px 0px 0px;
    font-size: 14px;
    line-height: 1.4;
    position: relative;
    -webkit-font-smoothing: subpixel-antialiased;
    background-color: var(--chat-bubble-background, #fff) !important;
    color: var(--chat-bubble-text, #000) !important;
    border-radius: 10px;
}

.translatable-content-wrapper {
    border-radius: 6px;
    padding: 0px;
}

.sc-message-meta-new {
    font-size: 8px;
    font-weight: 300;
    color: white;
    text-align: right;
    border-radius: 6px;
    text-transform: uppercase;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 0px !important;
    margin: 5px !important;
}

#translate-this-text {
    font-size: 10px;
    text-decoration: underline;
}

.after-translate-top {
    border-radius: 6px 6px 0px 0px;
    padding: 10px;
}

.after-translate-bottom {
    border-radius: 0px 0px 6px 6px;
    background: #d9d3d3;
    padding: 10px;
}

.lang-setting-icon {
    cursor: pointer;

    &:hover {
        font-size: 12px;
        color: #3892ab;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/messages/TextMessage.vue